import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { Link } from "react-router-dom"
import Logo from "./Logo"
import LogoMG from "./LogoMG"

export const Wrapper = styled.nav`
  display: flex;
  height: 40px;
  min-width: 1400px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
  padding: 0 16px;
`

export const LogoWrapper = styled(Link)`
  cursor: pointer;
`

export const Nav = styled.ul`
  display: flex;
  align-items: center;
  gap: 24px;
  list-style: none;
  margin: 0;
  padding: 0;
`

export const NavLink = styled(Link)<{ active?: boolean }>`
  display: flex;
  padding: 10px 24px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: ${({ active }) => (active ? "#3957d3" : "transparent")};
  text-decoration: none;
  color: #fff;
  font-family: SUIT;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  transition: background-color 0.2s ease;
  cursor: pointer;

  &:hover {
    background-color: #3957d3;
  }
`

const TimeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

const Time = styled.div`
  color: #f2f2f2;
  font-family: SUIT;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
`

const TimeDivider = styled.div`
  width: 1px;
  height: 18px;
  background: #e6e6e6;
`

const DateDisplay = styled.div`
  color: #f2f2f2;
  font-family: SUIT;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
`

const TopMenu: React.FC = () => {
  const [activeMenu, setActiveMenu] = useState<string>("dash-board") // 기본값 설정
  const [currentTime, setCurrentTime] = useState("")
  const [currentDate, setCurrentDate] = useState("")

  useEffect(() => {
    const updateTime = () => {
      const now = new Date()
      const hours = now.getHours()
      const minutes = now.getMinutes()
      const ampm = hours >= 12 ? "오후" : "오전"
      const formattedHours = hours % 12 || 12 // 12시간제로 변환
      const formattedMinutes = minutes.toString().padStart(2, "0")
      setCurrentTime(`${ampm} ${formattedHours} : ${formattedMinutes}`)

      const formattedDate = `${now.getFullYear()}년 ${
        now.getMonth() + 1
      }월 ${now.getDate()}일`
      setCurrentDate(formattedDate)
    }

    updateTime() // 처음 렌더링 시 실행
    const interval = setInterval(updateTime, 1000) // 1초마다 갱신

    return () => clearInterval(interval) // 컴포넌트 언마운트 시 정리
  }, [])

  const handleMenuClick = (menu: string) => {
    setActiveMenu(menu) // 클릭된 메뉴를 상태로 설정
  }

  return (
    <Wrapper>
      <LogoWrapper to="/" onClick={() => handleMenuClick("home")}>
        <Logo />
        {/* <LogoMG /> */}
      </LogoWrapper>
      <Nav>
        <NavLink
          to="/dash-board"
          active={activeMenu === "dash-board"}
          onClick={() => handleMenuClick("dash-board")}
        >
          대시보드
        </NavLink>
        <NavLink
          to="/energy-monitoring"
          active={activeMenu === "/energy-monitoring"}
          onClick={() => handleMenuClick("/energy-monitoring")}
        >
          에너지 모니터링
        </NavLink>
        <NavLink
          to="/renewable-energy-monitoring"
          active={activeMenu === "renewable-energy-monitoring"}
          onClick={() => handleMenuClick("renewable-energy-monitoring")}
        >
          재생 E 모니터링
        </NavLink>
        <NavLink
          to="/energy-trading"
          active={activeMenu === "energy-trading"}
          onClick={() => handleMenuClick("energy-trading")}
        >
          마을간 에너지 거래
        </NavLink>
        <NavLink to="https://www.michaellab.co.kr:25705/pageFarmList">
          설비 운영 및 설정
        </NavLink>
      </Nav>
      <TimeWrapper>
        <Time>{currentTime}</Time>
        <TimeDivider />
        <DateDisplay>{currentDate}</DateDisplay>
      </TimeWrapper>
    </Wrapper>
  )
}

export default TopMenu
